import React from "react";
import DataTable from "../../../DataTable/DataTable";
import DatePickerInput from "../../../DatePickerInput/DatePickerInput";

class NightAuditNoShow extends React.Component {
  constructor(props) {
    super(props)
    this.itemsAndTotal = this.itemsAndTotal.bind(this);
  };

  render() {
    return (
      <div>
        <div className="alert alert-warning show">
          <h4 style={{ textAlign: 'center' }}><strong>{I18n.t('all_no_shows_listed_helper_text')}</strong></h4>
        </div>
        <div className="panel panel-default">
          <div className="panel-body">
            <h3 className="panel-heading-text clear-bottom-margin">{I18n.t('no_shows')} - {I18n.t('count')} {this.props.totals.no_shows_count ? this.props.totals.no_shows_count : 0}</h3>
            <div className="col-sm-2 no-show-date-wrapper" >
              <DatePickerInput
                selectedDate={this.props.no_show_date ? this.props.no_show_date : this.props.postDate}
                dateFormat={this.props.date_format} 
                onChange={this.props.onChangeNoShowDate} 
              />
            </div>
            <div className="col-sm-12">
              <DataTable 
                endpoint={`/admin/night-audits/${this.props.excluded_no_shows.length ? this.props.excluded_no_shows : false}/no-shows`} 
                date_format={this.props.date_format} 
                time_format={this.props.time_format}
                delimiter={I18n.t('number.currency.format.delimiter')} 
                separator={I18n.t('number.currency.format.separator')} 
                itemsAndTotal={this.itemsAndTotal} 
                night_audit={true} 
                audit_date={this.props.no_show_date ? this.props.no_show_date : this.props.no_show_date} 
                exclude={this.props.excludeNoShow} 
                export_csv_endpoint={`/admin/night-audits/${this.props.excluded_no_shows.length ? this.props.excluded_no_shows : false}/export_no_show_csv.csv`}
                />
            </div>
          </div>
        </div>
      </div>
    );
  };

  itemsAndTotal(items, total, count) {
    this.props.collectNoShows(items, count)
  };

};

export default NightAuditNoShow